var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "home safe-area-inset-bottom" }, [
      _c("img", {
        attrs: {
          src:
            "https://wlmvp-cos.weiling.cn/adlandingpage/willingDemoPages/worktable-preview.png",
          alt: "preview page"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }